export default {
  init() {
    const dashboardButtons = $('.membership-dashboard button'),
          closeButton = $('.close-button');

    dashboardButtons.on('click', function () {
      if( $(this).hasClass('.is--active') ) {
        $(this).removeClass('.is--active');
        $(this).parents('.dashboard-row').find('.row-content-container').removeClass('is--toggled');
      } else {
        var boxContent = $(this).next('.dashboard-section-content-container').html();
        $('.btn.is--active').removeClass('is--active');
        $('.row-content-container.is--toggled').removeClass('is--toggled');
        $(this).addClass('is--active');
        $(this).parents('.dashboard-row').find('.row-content-container').addClass('is--toggled');
        $(this).parents('.dashboard-row').find('.row-content-container > .content-container').html(boxContent);
      }
    });

    closeButton.on('click', function () {
      var dashboardRow = $(this).parents('.dashboard-row');

      dashboardRow.find('.is--active').removeClass('is--active');
      dashboardRow.find('.row-content-container').removeClass('is--toggled');
    });
  }
}
